
export class OperationEfficiencyModel {
    operationId: string;
    operationDesc: string;
    totalGarmentsCompleted: number; // total garments
    efficiency: number; // SUM(garments * smv) of each workstation for the operation / total man hours per hour(60 mins) * no of workstation 
    totalSpentTime: number// total garments * planned smv
    operationSmv: number;

    constructor(operationId: string,
        operationDesc: string,
        totalGarmentsCompleted: number,
        efficiency: number,
        totalSpentTime: number,
        operationSmv: number
        ) {
            this.operationId = operationId;
            this.operationDesc = operationDesc;
            this.totalGarmentsCompleted = totalGarmentsCompleted;
            this.efficiency = efficiency;
            this.totalSpentTime = totalSpentTime;
            this.operationSmv = operationSmv;
    }
}